module.exports = __webpack_public_path__ + "img/2.387625b8.jpg";